/* eslint-disable */
import axios from 'axios'
import Vue from 'vue'
// import {root} from '../utils/chHostconfig.js'
import qs from 'qs';
import { isApp ,jsBridgeForSSAI } from '@/utils/index.js';



function isMobile() {
  let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile!= null
}
// console.log('当前设备是什么',isMobile());
let ismobile=isMobile();
window.getData = (data) => {
  if (data !== undefined) {
    const userToken = JSON.parse(data).data.user_token;
    localStorage.setItem('user_token', userToken)
    try {
      console.log( JSON.parse(data), userToken );
    }catch(e) {
      console.log(e)
  }
  }
},
// const baseUrl = root
axios.interceptors.request.use(config => {
  if (isApp()) {
    jsBridgeForSSAI('getData', {
      key: 'user_token'
    }, 'getData');
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  let Token=localStorage.getItem('uc-mtLoginToken')||'';
  let token = localStorage.getItem('user_token') || ''
  let ddToken = localStorage.getItem('ddToken') || ''
  if (Token && !config.url.includes('dlapi') && !config.url.includes('songshuai')) {
    config.headers['Token'] = Token;
  }
  if (token && !config.url.includes('dlapi')&& !config.url.includes('mtapi')) {
    config.headers.common['Authorization'] = token;
  }
  if(ddToken&&!config.url.includes('dlapi')&& !config.url.includes('mtapi')){
    config.headers.common['Authorization']  = ddToken;
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  console.log(error)
  return Promise.resolve(error)
})

function checkStatus (response) {
  console.log(response)
  // 登录失效
  if (response.data.code === -9999997||response.data.code === -9999992||response.data.code === -9999993) {
    // Message({
    //   message: '登录失效，请重新登录',
    //   type: 'error',
    //   duration: 2 * 1000
    // })
    const isIpad = /ipad|android/i.test(navigator.userAgent)
    if (window.location.href.includes('uc-mobile')&&!isIpad) {
      Vue.prototype.$toast('登录失效，请重新登录')
      setTimeout(function () {
        window.location.href = `${window.location.origin}/uc-mobile/login`;
      }, 1000)
      // return $toast('登录失效，请重新登录')
    }else{
      setTimeout(function () {
        Vue.prototype.$toast('登录失效，请重新登录')
        if (isApp() && Number(loginType) === 1) {
          jsBridgeForSSAI('loginFailure');
          return
        }
        window.location.href = `${window.location.origin}/uc-web/login`;
      }, 1000)
      // return toast('登录失效，请重新登录')
    }
  } else {
    return response.data
  }
}
let loginType= 0;

window.getLoginType = (data) => {
  if (data !== undefined) {
    console.log(data, 'apk返回');
    loginType = JSON.parse(data).data.loginType;
  }
};

export default {
  post (res) {
    return axios({
      method: 'post',
      // baseURL: baseUrl,
      url: res.url,
      data: qs.stringify(res.data),
      timeout: 10000
      // headers: head
    }).then(
      (response) => {
        // console.log(response)
        if (isApp()) {
          jsBridgeForSSAI('getData', {
            key: 'loginType',
          }, 'getLoginType');
        }
        return checkStatus(response)
      }
    ).catch(error => {
      console.log(error)
    })
  },
  get (url, params) {
    return axios({
      method: 'get',
      // baseURL: baseUrl,
      url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        if (isApp()) {
          jsBridgeForSSAI('getData', {
            key: 'loginType',
          }, 'getLoginType');
        }
        return checkStatus(response)
      }
    ).catch(
      (rej) => {
        return rej
      }
    )
  }
  // setToken: function (token) {
  //   head['yx-token'] = token
  // }
}
